import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-distribution-dates',
  templateUrl: './payment-distribution-dates.component.html',
  styleUrls: ['./payment-distribution-dates.component.css']
})
export class PaymentDistributionDatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
